import {
	createRouter,
	createWebHashHistory
} from 'vue-router'
import Layout from '../Layout/Layout.vue'
import store from '@/store'

const routes = [{
		path: '/login',
		name: '登录',
		component: () => import('../views/LoginView/Login.vue')
	},
	{
		path: '/',
		redirect: '/dashboard',
		component: Layout,
		children: [{
				path: 'dashboard',
				name: '首页',
				component: () => import('../views/DashboardView/Dashboard.vue')
			},
			{
				path: 'employee',
				name: '员工管理',
				component: () => import('../views/EmployeeView/Employee.vue')
			},
			{
				path: 'employee/add',
				name: '新增员工',
				component: () => import('../views/EmployeeView/AddEmployee.vue')
			},
			{
				path: 'machine',
				name: '设备管理',
				component: () => import('../views/MachineView/Machine.vue')
			},
			{
				path: 'machine/add',
				name: '新增设备',
				component: () => import('../views/MachineView/AddMachine.vue')
			},
			{
				path: 'machine/detail',
				name: '设备详情',
				component: () => import('../views/MachineView/MachineDetail.vue')
			},
			{
				path: 'machine/sale',
				name: '售出记录',
				component: () => import('../views/MachineView/MachineSale.vue')
			},
			{
				path: 'category',
				name: '设备分类',
				component: () => import('../views/CategoryView/Category.vue')
			},
			{
				path: 'category/add',
				name: '新增设备分类',
				component: () => import('../views/CategoryView/AddCategory.vue')
			},
			{
				path: 'location',
				name: '设备位置',
				component: () => import('../views/LocationView/Location.vue')
			},
			{
				path: 'location/add',
				name: '新增设备位置',
				component: () => import('../views/LocationView/AddLocation.vue')
			},
			{
				path: 'swiper',
				name: '轮播图管理',
				component: () => import('../views/SwiperView/Swiper.vue')
			},
			{
				path: 'swiper/add',
				name: '新增轮播图',
				component: () => import('../views/SwiperView/AddSwiper.vue')
			},
			{
				path: 'user/info',
				name: '用户信息',
				component: () => import('../views/UserInfoView/UserInfo.vue')
			},
			{
				path: 'user/detail',
				name: '用户详情',
				component: () => import('../views/UserInfoView/UserDetail.vue')
			},
			{
				path: 'user/upload',
				name: '用户上传',
				component: () => import('../views/UserUploadView/UserUpload.vue')
			},
			{
				path: '/upload/detail',
				name: '上传详情',
				component: () => import('../views/UserUploadView/UploadDetail.vue')
			},
			{
				path: 'user/request',
				name: '用户求购',
				component: () => import('../views/UserRequestView/UserRequest.vue')
			},
			{
				path: '/request/detail',
				name: '求购详情',
				component: () => import('../views/UserRequestView/RequestDetail.vue')
			},
			{
				path: 'user/feedback',
				name: '用户反馈',
				component: () => import('../views/FeedbackView/Feedback.vue')
			},
			{
				path: 'user/favorite',
				name: '用户收藏',
				component: () => import('../views/FavoriteView/Favorite.vue')
			},
			{
				path: 'user/history',
				name: '历史记录',
				component: () => import('../views/HistoryView/History.vue')
			}
		]
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

// ✅ 全局路由前置守卫：未登录跳转登录页，登录放行
router.beforeEach((to, from, next) => {
	const token = store.getters['user/token']

	if (to.path === '/login') {
		// 如果已经登录，还访问登录页，直接跳转首页
		if (token) {
			next({
				path: '/'
			})
		} else {
			next()
		}
	} else {
		// 非登录页，如果未登录就拦截跳转回登录页
		if (!token) {
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				} // 携带跳转参数
			})
		} else {
			next()
		}
	}
})

export default router